// apps/web/app/microgrid/lit/components/PathCTA.tsx
'use client';
import React, { useEffect, useRef } from 'react';
import Link from 'next/link';
import { sectionViewOnce, track } from '../components/ga';
import './styles/PathCTA.css';

const PathCTA: React.FC = () => {
  const ref = useRef<HTMLElement | null>(null);
  useEffect(() => ref.current ? sectionViewOnce(ref.current, 'path_cta') : undefined, []);

  return (
    <section id="path" className="path" ref={ref}>
      <h2>Your Path to a Brighter Home</h2>
      <p className="subtitle">Just three easy steps.</p>

      <div className="steps">
        <div className="step-card"><div className="step-num">1</div><h3>Get Your Quote</h3><p>Fill out our quick form for a tailored proposal.</p></div>
        <div className="step-card"><div className="step-num">2</div><h3>Quick e-Sign</h3><p>Review and e-sign your contract from anywhere.</p></div>
        <div className="step-card"><div className="step-num">3</div><h3>Schedule Installation</h3><p>Pick an installation date that works for you.</p></div>
      </div>

      <div className="path-cta">
        <p style={{ marginTop: 28, marginBottom: 12, textAlign: 'center' }}>
          Ready to Light Up Your Home?<br />Click below to generate your personalized proposal and get started.
        </p>
        <Link
          href="https://alwayslittx.com/vision-engine"
          prefetch={false}
          target="_top"
          className="cta-button"
          onClick={() => track('select_content', { content_type: 'link', item_id: 'path_cta', link_url: 'https://alwayslittx.com/vision-engine', location: 'path' })}
        >
          Let’s Do It
        </Link>
      </div>
    </section>
  );
};

export default PathCTA;
